export default function getResource(label, vars = []) {
    const resources = {
        estimatedTotal: 'Total estimé',
        googlePayErrorMessage:
            'Unable to place your order. Trouble connecting to Google Pay. Please use a different payment method or try again later.<br /><br />If applicable, we have reversed any pending charges to your account.',
        googlePayErrorOkButton: 'OK',
        googlePayErrorTitle: 'Error',
        googlePayGenericError: 'We experienced an error, please try again',
        total: 'Total'
    };

    return resources[label];
}
